export default __webpack_public_path__ + "static/media/FAC4.ebd8fee0.jpg";